export const IS_DEV = /dev=4111/.test(location.search)

export const IS_IOS = /iphone|ipad/i.test(navigator.userAgent)
export const IS_WECHAT = /micromessager/i.test(navigator.userAgent)

export const API_BASE_URL = IS_DEV ? 'http://dev.wx-love-api.afunapp.com/' : 'https://wx-love-api.afunapp.com/'

export const VERSION = '1.1.6'

export const APP_ID = 'wxbc9a7f5892303ffc'

export const WEB_PLATFORM = 2 // 标识客户端平台

export const API_KEY = 'AjGFexDr2WERpKSHrV9PFAMrImlANq67'

export const TA_APP_ID = IS_DEV ? 'e648757b57a149daa67b098b0b5b0c00' : 'e7f259dcb9e342a59c5ba1f7c8a0bdba'

export const IMG_ROOT = '' // 图片base

export const SESSION_EXPIRE_TIME = 2592000000
